import InfiniteTravelersList from './infinite-traveler-list';

export default InfiniteTravelersList;
